import React from 'react';
import { capitalizeFirstLetter } from '../../../util/genericHelpers';
import { FormattedMessage } from 'react-intl';
import { Icons, PrimaryButton } from '../../../components';
import classNames from 'classnames';
import css from './Sections.module.css';

const CustomEnhancedServices = ({ talentPlus, title }) => {
  // Filter only custom services
  const customServices =
    talentPlus?.filter(service => service?.type?.toLowerCase() === 'custom service') || [];

  // Format the available services
  const availableItems = customServices.map(custom => ({
    title: capitalizeFirstLetter(custom.service), // Correct title mapping
    price: Number(custom.price).toFixed(2), // Convert to float with 2 decimal places
  }));

  return (
    <>
      <div className={css.getCustomVideo}>
        <h2>
          <FormattedMessage id="EnhancedServices.CustomEnahncedServices.modelTitle" />{' '}
          <FormattedMessage id="SectionAppearances.from" values={{ title }} />
        </h2>
      </div>

      {availableItems.length > 0
        ? availableItems.map((item, idx) => (
            <div className={css.bookingSec} key={idx}>
              <div className={classNames(css.offerSec, css.withoutIconSec)}>
                <div className={css.offerContent}>
                  <h2>{item.title}</h2>
                  <p>${item.price} per hour</p>
                  <p>
                    <FormattedMessage id="EnhancedServices.CustomEnahncedServices.offerMessage" />
                  </p>
                  <PrimaryButton className={css.bookBtn}>
                    <Icons name="security" />
                    <FormattedMessage id="EnhancedServices.SectionExclusedTraining.buyNowButton" />
                  </PrimaryButton>
                </div>
              </div>
            </div>
          ))
        : null}
    </>
  );
};

export default CustomEnhancedServices;
